import type { MimeType } from './mimeType';
import { getViewerType, isPdf, isImage, isVideo, isAudio, isElse, Viewer } from './isMedia';
import { computed, watch } from 'vue';



const extensionToMimeType: Record<string, MimeType> = {
    pdf: "application/pdf",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    mp3: "audio/mpeg",
    m4a: "audio/mp4",
    ogg: "audio/ogg",
    wav: "audio/wav",
    webm: "audio/webm",
    aac: "audio/aac",
    mp4: "video/mp4",
    //webm: "video/webm",
    txt: "text/plain",
    html: "text/html",
    zip: "application/zip",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xls: "application/vnd.ms-excel",
    webp: "image/webp",
    mov: "video/quicktime",
};


const mimeTypeToExtension: Record<MimeType, string> = {
    "application/pdf": "pdf",
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/jpg": "jpeg",
    "audio/mpeg": "mp3",
    "audio/ogg": "ogg",
    "audio/wav": "wav",
    "audio/mp4" : "m4a",
    "audio/webm": "webm",
    "audio/aac": "aac",
    "video/mp4": "mp4",
    "video/webm": "webm",
    "text/plain": "txt",
    "text/html": "html",
    "application/zip": "zip",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
    "application/vnd.ms-excel": "xls",
    "image/webp": "webp",
    "video/quicktime": "mov",
}


// Maybe a way to rewrite the application and use a centralized points of truth
const allowedMimeType: Record<MimeType, boolean> = {
    "application/pdf": true,
    "image/jpeg": true,
    "image/png": true,
    "image/jpg": true,
    "audio/mpeg": true,
    "audio/ogg": true,
    "audio/wav": true,
    "audio/webm": false,
    "audio/aac": true,
    "video/mp4": true,
    "video/webm": false,
    "audio/mp4": true, 
    "text/plain": true,
    "text/html": false,
    "application/zip": false,
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": true,
    "application/vnd.ms-excel": true,
    "image/webp": false,
    "video/quicktime": true,
}





function resolveMimeType(type: string): MimeType | undefined {
    const normalizedType = type.toLowerCase();
    
    let mimeType: MimeType | undefined = extensionToMimeType[normalizedType];

    if (!mimeType && mimeTypeToExtension[normalizedType as MimeType]) {
        mimeType = normalizedType as MimeType;
    }

    return mimeType;
}



const allowedAudios = computed((): MimeType[] => {
    const audioMimeTypes = Object.keys(allowedMimeType).filter((key) => key.includes("audio")) as MimeType[];
    return audioMimeTypes.filter((audio) => allowedMimeType[audio]);
});

export { extensionToMimeType, mimeTypeToExtension, resolveMimeType, MimeType, allowedMimeType }
export { getViewerType, isPdf, isImage, isVideo, isAudio, isElse, Viewer, allowedAudios }